import React from 'react';
import { OptionWizardRoomLink } from './OptionGroupWizard.types';
import { OptionRoomLinkEditor } from '../OptionRoomLinkEditor';

export interface OptionGroupWizardLinkRoomsStepProps {
    projectId: number;
    value: OptionWizardRoomLink[];
    /** Rooms with a live order - locked so they cannot be unlinked. */
    lockedRoomIds?: number[];
    onChange(newValue: OptionWizardRoomLink[]): void;
}

export const OptionGroupWizardLinkRoomsStep: React.FC<OptionGroupWizardLinkRoomsStepProps> = ({
    projectId,
    value,
    lockedRoomIds,
    onChange,
}) => {
    return <OptionRoomLinkEditor projectId={projectId} value={value} lockedRoomIds={lockedRoomIds} onChange={onChange} />;
};
